import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { AuthcheckService } from 'src/app/services/authcheck.service';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'default-layout',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.css'],
  standalone: false,
})
export class DefaultComponent implements OnInit {
  loggedIn = false;
  accountMenuOpen = false;
  hideMobileBottomNav = false;
  private readonly unsubscribeAll: Subject<void> = new Subject<void>();

  constructor(
    private authCheckService: AuthcheckService,
    private tokenService: TokenService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit(): void {
    this.authCheckService.authStatus
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((status) => {
        this.loggedIn = status;
        if (!status) {
          this.accountMenuOpen = false;
        }
      });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        takeUntil(this.unsubscribeAll),
      )
      .subscribe(() => {
        this.hideMobileBottomNav = this.shouldHideMobileBottomNav(
          this.router.url,
        );
        if (isPlatformBrowser(this.platformId)) {
          if (this.hideMobileBottomNav) {
            document.body.classList.add('hide-bottom-nav');
          } else {
            document.body.classList.remove('hide-bottom-nav');
          }
        }
      });
  }

  private shouldHideMobileBottomNav(url: string): boolean {
    return url.startsWith('/accomodation/');
  }

  toggleAccountMenu(): void {
    this.accountMenuOpen = !this.accountMenuOpen;
  }

  closeAccountMenu(): void {
    this.accountMenuOpen = false;
  }

  logout(): void {
    this.tokenService.remove();
    this.authCheckService.changeAuthStatus(false);
    this.accountMenuOpen = false;
    this.router.navigateByUrl('/');
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.remove('hide-bottom-nav');
    }
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
